import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=9cdd2f5c&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=ts&"
export * from "./EditPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=9cdd2f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdd2f5c",
  null
  
)

export default component.exports